export const SNAPSHOT_STATUSES = {
  PENDING: 'PENDING',
  EXPORTING: 'EXPORTING',
  IMPORTING: 'IMPORTING',
  MASKING: 'MASKING',
  PACKAGING: 'PACKAGING',
  READY: 'READY',
  DOWNLOADED: 'DOWNLOADED',
  FAILED: 'FAILED',
  REVOKED: 'REVOKED',
  EXPIRED: 'EXPIRED',
};

export const STATUS_LIST = Object.values(SNAPSHOT_STATUSES);

export const STATUS_LABELS = {
  [SNAPSHOT_STATUSES.PENDING]: 'Pending',
  [SNAPSHOT_STATUSES.EXPORTING]: 'Exporting',
  [SNAPSHOT_STATUSES.IMPORTING]: 'Importing',
  [SNAPSHOT_STATUSES.MASKING]: 'Masking',
  [SNAPSHOT_STATUSES.PACKAGING]: 'Packaging',
  [SNAPSHOT_STATUSES.READY]: 'Ready',
  [SNAPSHOT_STATUSES.DOWNLOADED]: 'Downloaded',
  [SNAPSHOT_STATUSES.FAILED]: 'Failed',
  [SNAPSHOT_STATUSES.REVOKED]: 'Revoked',
  [SNAPSHOT_STATUSES.EXPIRED]: 'Expired',
};

export const STATUS_COLORS = {
  [SNAPSHOT_STATUSES.PENDING]: 'gray',
  [SNAPSHOT_STATUSES.EXPORTING]: 'blue',
  [SNAPSHOT_STATUSES.IMPORTING]: 'blue',
  [SNAPSHOT_STATUSES.MASKING]: 'blue',
  [SNAPSHOT_STATUSES.PACKAGING]: 'blue',
  [SNAPSHOT_STATUSES.READY]: 'green',
  [SNAPSHOT_STATUSES.DOWNLOADED]: 'green',
  [SNAPSHOT_STATUSES.FAILED]: 'red',
  [SNAPSHOT_STATUSES.REVOKED]: 'red',
  [SNAPSHOT_STATUSES.EXPIRED]: 'orange',
};

export const PROGRESS_STEPS = [
  { key: SNAPSHOT_STATUSES.EXPORTING, label: 'Export' },
  { key: SNAPSHOT_STATUSES.IMPORTING, label: 'Import' },
  { key: SNAPSHOT_STATUSES.MASKING, label: 'Mask' },
  { key: SNAPSHOT_STATUSES.PACKAGING, label: 'Package' },
  { key: SNAPSHOT_STATUSES.READY, label: 'Ready' },
];

export const TERMINAL_STATUSES = [
  SNAPSHOT_STATUSES.DOWNLOADED,
  SNAPSHOT_STATUSES.FAILED,
  SNAPSHOT_STATUSES.REVOKED,
  SNAPSHOT_STATUSES.EXPIRED,
];

export const REASON_MIN_LENGTH = 10;
export const REASON_MAX_LENGTH = 500;
